import { Icon, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

export const GeneralErrorMessage = () => {
  return (
    <Row gap={6} alignItems="center" marginBottom={16}>
      <Icon name="alert-circle" />
      <Text color={Colors.error_500}>
        Oops! It looks like a few required fields were left empty.
      </Text>
    </Row>
  );
};
